export type PaymentMethod = keyof typeof PAYMENT_METHOD;
export type DeliveryMethod = keyof typeof DELIVERY_METHOD;

export const PAYMENT_METHOD = {
    CASH: 'CASH',
    CARD: 'CARD',
};

export const PAYMENT_METHOD_COLOR = {
    CASH: 'success',
    CARD: 'info',
};

export const DELIVERY_METHOD = {
    PICKUP: 'PICKUP',
    DELIVERY: 'DELIVERY',
};
